import React from 'react'

import moment from 'moment'

import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import Presentations from './Presentations'
import ReturnButton from './ReturnButton'

const DEFAULT_ATTRIBUTES = {
  address: '',
  url: '',
}

function EventInfo({ attributes = DEFAULT_ATTRIBUTES, presentations = EMPTY_ARRAY }) {
  return (
    <div className="event-info">
      <p className="event-info__date">
        <Icon
          className="u-mr10"
          type={['far', 'calendar']}
          color="green"
        />
        {`${moment.utc(attributes.dateFrom).format('dddd')} |
          ${moment.utc(attributes.dateFrom).format('MMM DD, YYYY')}
         -
          ${moment.utc(attributes.dateTo).format('dddd')} |
          ${moment.utc(attributes.dateTo).format('MMM DD, YYYY')}`
        }
      </p>
      {attributes.address && (
        <p className="event-info__address">
          <Icon
            className="u-mr10"
            type={['far', 'map-marker']}
            color="green"
          />
          {attributes.address}
        </p>
      )}
      <p className="event-info__description">{attributes.description}</p>
      {presentations && presentations.length > 0 && (
        <Presentations presentations={presentations} />
      )}
      {attributes.url && (
        <p>
          <span className="u-mr10">More information: </span>
          <a
            className="link link--primary text-regular"
            href={attributes.url}
          >
            {attributes.url}
          </a>
        </p>
      )}

      <ReturnButton buttonClassName="event-page__cta-desktop" />
    </div>
  )
}

EventInfo.propTypes = {
  presentations: PropTypes.array,
  attributes: PropTypes.shape({
    date: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    address: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
}

export default EventInfo
